{
  "catalog": {
    "title": "Catalogue des cours",
    "subtitle": "Parcourez les cours publiés par les enseignants de la plateforme.",
    "searchLabel": "Rechercher",
    "searchPlaceholder": "espagnol conversation",
    "domain": "Domaine",
    "allDomains": "Tous les domaines",
    "level": "Niveau",
    "allLevels": "Tous les niveaux",
    "lessons": "Leçons",
    "lessonCount_one": "{{count}} leçon",
    "lessonCount_other": "{{count}} leçons",
    "empty": "Aucun cours ne correspond à cette recherche.",
    "loadFailed": "Le catalogue n'a pas pu être chargé.",
    "rankedResults": "Les {{shown}} cours les plus pertinents, sur {{total}} correspondances.",
    "results": "Résultats",
    "suggestions": "Suggestions",
    "suggestionCount_one": "{{count}} suggestion",
    "suggestionCount_other": "{{count}} suggestions"
  },
  "levels": {
    "beginner": "Débutant",
    "intermediate": "Intermédiaire",
    "advanced": "Avancé"
  },
  "status": {
    "draft": "Brouillon",
    "published": "Publié",
    "archived": "Archivé"
  },
  "visibility": {
    "public": "Public — visible dans le catalogue",
    "unlisted": "Non listé — accessible par lien direct",
    "private": "Privé — visible de vous seul"
  },
  "blockers": {
    "title_too_short": "Le titre doit faire au moins 3 caractères.",
    "description_too_short": "La description doit faire au moins 50 caractères.",
    "no_published_lesson": "Le cours doit contenir au moins une leçon publiée."
  },
  "course": {
    "about": "À propos de ce cours",
    "curriculum": "Programme",
    "noLesson": "Ce cours n'a pas encore de leçon publiée.",
    "read": "Lire",
    "locked": "Réservé",
    "notFound": "Ce cours est introuvable.",
    "lessonFailed": "Cette leçon n'a pas pu être chargée.",
    "follow": "Suivre ce cours"
  },
  "nav": {
    "myCourses": "Cours enseignés"
  },
  "mine": {
    "title": "Mes cours",
    "subtitle": "Vos cours, brouillons et archives compris.",
    "createTitle": "Créer un cours",
    "courseTitle": "Titre",
    "chooseDomain": "Choisir un domaine",
    "create": "Créer",
    "empty": "Vous n'avez pas encore créé de cours.",
    "loadFailed": "Vos cours n'ont pas pu être chargés."
  },
  "editor": {
    "metadata": "Informations",
    "subtitle": "Sous-titre",
    "description": "Description",
    "descriptionHint": "Au moins 50 caractères pour pouvoir publier.",
    "noLevel": "Non précisé",
    "visibility": "Visibilité",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "publish": "Publier",
    "unpublish": "Dépublier",
    "archive": "Archiver",
    "delete": "Supprimer",
    "blockersTitle": "Il manque encore quelque chose pour publier :",
    "curriculum": "Programme",
    "noLesson": "Aucune leçon pour l'instant.",
    "newLesson": "Titre de la nouvelle leçon",
    "addLesson": "Ajouter",
    "editLesson": "Modifier",
    "removeLesson": "Supprimer la leçon",
    "moveUp": "Monter",
    "moveDown": "Descendre",
    "addBlock": "Ajouter un bloc",
    "removeBlock": "Supprimer le bloc",
    "blockType": "Type de bloc",
    "blockContent": "Contenu du bloc",
    "headingLevel": "Niveau de titre",
    "level": "Titre {{level}}",
    "textHint": "Écrivez ici…",
    "bulletHint": "Une ligne par élément de liste",
    "blocks": {
      "paragraph": "Paragraphe",
      "heading": "Titre",
      "bulletList": "Liste à puces",
      "blockquote": "Citation",
      "codeBlock": "Bloc de code"
    },
    "upGlyph": "↑",
    "downGlyph": "↓",
    "removeGlyph": "✕"
  },
  "lesson": {
    "title": "Titre de la leçon",
    "content": "Contenu",
    "publish": "Publier la leçon",
    "unpublish": "Repasser en brouillon",
    "isPreview": "Consultable sans inscription",
    "previewHint": "Une leçon d'aperçu est lisible par tout visiteur ; les autres demandent une inscription.",
    "backToCourse": "Retour au cours",
    "notFound": "Cette leçon est introuvable."
  },
  "resources": {
    "title": "Ressources",
    "type": "Type",
    "label": "Intitulé",
    "url": "Adresse",
    "video": "Vidéo",
    "link": "Lien",
    "pdf": "Document PDF",
    "image": "Image",
    "download": "Télécharger le document",
    "fileHint": "Le fichier est déposé puis vérifié avant d'être attaché à la leçon.",
    "attach": "Attacher",
    "remove": "Retirer",
    "providersHint": "Vidéos acceptées : YouTube, Vimeo, Dailymotion. Les liens doivent être en https.",
    "file": "Fichier"
  },
  "exercises": {
    "add": "Ajouter un exercice",
    "addHint": "L'exercice naît avec son seul titre. Le seuil de réussite, le blocage et le nombre de tentatives se règlent ensuite, une fois les questions écrites.",
    "titleLabel": "Titre de l'exercice",
    "isBlocking": "Bloquant : la leçon suivante reste verrouillée tant que l'exercice n'est pas réussi",
    "shuffle": "Mélanger les questions et les propositions",
    "passingScore": "Seuil de réussite (%)",
    "maxAttempts": "Tentatives autorisées",
    "unlimited": "Illimité",
    "gradingMode": "Correction",
    "maxScore": "Barème total : {{total}} points",
    "questions": "Questions",
    "noQuestion": "Aucune question pour l'instant.",
    "addQuestion": "Ajouter la question",
    "questionType": "Type de question",
    "prompt": "Énoncé",
    "choices": "Propositions",
    "choiceLabel": "Proposition {{index}}",
    "markCorrect": "Bonne réponse",
    "addChoice": "Ajouter une proposition",
    "removeChoice": "Retirer cette proposition",
    "answerKeys": "Réponses acceptées",
    "answerKeysHint": "Plusieurs orthographes peuvent être acceptées pour la même bonne réponse.",
    "answerKeyLabel": "Réponse acceptée {{index}}",
    "addAnswerKey": "Ajouter une réponse acceptée",
    "removeAnswerKey": "Retirer cette réponse",
    "explanation": "Explication",
    "explanationHint": "Affichée à l'élève après la correction, jamais avec l'énoncé.",
    "points": "{{points}} points",
    "correctAnswer": "bonne réponse",
    "moveUp": "Monter la question",
    "moveDown": "Descendre la question",
    "removeQuestion": "Supprimer la question",
    "remove": "Supprimer l'exercice",
    "preview": "Prévisualiser",
    "hidePreview": "Masquer l'aperçu",
    "previewTitle": "Aperçu élève",
    "previewEmpty": "Cet exercice n'a encore aucune question.",
    "previewMeta": "Seuil de réussite : {{score}} % · barème : {{total}} points",
    "previewAnswerPlaceholder": "Réponse de l'élève",
    "blockingNotice": "débloque la leçon suivante",
    "attemptsNotice_one": "{{count}} tentative",
    "attemptsNotice_other": "{{count}} tentatives",
    "types": {
      "single_choice": "Choix unique",
      "multiple_choice": "Choix multiples",
      "true_false": "Vrai ou faux",
      "short_text": "Réponse courte",
      "number": "Nombre",
      "open_text": "Réponse libre (correction manuelle)",
      "file_upload": "Dépôt de fichier (correction manuelle)"
    },
    "gradingModes": {
      "auto": "automatique",
      "manual": "manuelle",
      "mixed": "mixte"
    },
    "reasons": {
      "blocking_exercise_without_question": "Un exercice bloquant doit avoir au moins une question.",
      "question_without_prompt": "Une question doit avoir un énoncé.",
      "question_needs_two_choices": "Une question à choix demande au moins deux propositions.",
      "single_choice_needs_exactly_one_correct": "Une question à choix unique doit avoir exactement une bonne réponse.",
      "multiple_choice_needs_a_correct_choice": "Une question à choix multiples doit avoir au moins une bonne réponse.",
      "true_false_needs_two_choices": "Une question vrai/faux doit avoir exactement deux propositions.",
      "question_without_answer_key": "Une question à réponse libre demande au moins une réponse acceptée."
    },
    "editQuestion": "Modifier la question",
    "instructions": "Consignes",
    "instructionsHint": "Affichées à l'élève avant qu'il ne commence l'exercice."
  }
}
